import { Translate } from '@above-the-treeline/localization';

const LinkName = {
	Search: '/search',
	Home: '/home',
	YourBooks: '/yourbooks',
	Help: '/help',
};

export interface INavigationItem {
	icon: string;
	label: string | React.ReactNode;
	linkTo?: string;
}

const NavigationItemsEnum = {
	HomeNav: {
		icon: 'home',
		label: <Translate id="home" />,
		linkTo: LinkName.Home,
	},
	SearchNav: {
		icon: 'search-icon',
		label: <Translate id="search" />,
		linkTo: LinkName.Search,
	},
	YourBooksNav: {
		icon: 'books',
		label: <Translate id="your_books" />,
		linkTo: LinkName.YourBooks,
	},
	FeedbackNav: {
		icon: 'help-icon',
		label: <Translate id="feedback" />,
	},
};

export default NavigationItemsEnum;
